import React from "react";

import { ColorPrimary, IgTypography } from "@intelligems/ig-theme";
import { hexToRgbA } from "@intelligems/ig-utils";
import { Box, Grid } from "@mui/material";

import { ChangeLogProps, formatText } from "../utils";

export const UpdatedKeyValueLine = ({
  k,
  value,
  dontFormat,
}: Omit<ChangeLogProps, "key">) => {
  if (k === "listKey") {
    return null;
  }

  return (
    <Grid container item className={"update-key-value-line"} key={k}>
      <Box
        alignItems={"center"}
        sx={{
          padding: "2px 16px 2px 16px",
          width: "100%",
          borderRadius: "5px",
          border: `1px solid ${hexToRgbA(ColorPrimary.main, 0.4)}`,
        }}
      >
        <IgTypography sx={{ fontWeight: 600 }}>
          {formatText(k, k)}{" "}
        </IgTypography>
        <IgTypography> changed from </IgTypography>
        <IgTypography sx={{ fontWeight: 600 }}>
          {dontFormat ? `${value.data.from}` : formatText(k, value.data.from)}
        </IgTypography>
        <IgTypography> to </IgTypography>
        <IgTypography sx={{ fontWeight: 600 }}>
          {dontFormat ? `${value.data.to}` : formatText(k, value.data.to)}
        </IgTypography>
      </Box>
    </Grid>
  );
};
